import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-097c1f84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "firm-selector" }
const _hoisted_2 = { class: "home" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashboard-bg" }, null, -1))
const _hoisted_4 = { class: "select-a-firm" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-blue-line" }, null, -1))
const _hoisted_6 = { class: "select-a-firm-body" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please Select a Practice:", -1))
const _hoisted_8 = { class: "radio" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "radio-elmt" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
], -1))
const _hoisted_12 = { class: "radio-text" }
const _hoisted_13 = {
  key: 0,
  class: "error"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-info-circle mr-2" }, null, -1))
const _hoisted_15 = { class: "action-btn" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", {
              class: _normalizeClass(['firm-selection-box', 'mt-1', _ctx.errorProceed ? 'no-selection' : ''])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.practices, (p) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: p.practiceId,
                  class: "radio-box"
                }, [
                  _createElementVNode("label", _hoisted_8, [
                    _createElementVNode("input", {
                      type: "radio",
                      name: "filter-type",
                      onClick: $event => (_ctx.setSelectedPractice(p))
                    }, null, 8, _hoisted_9),
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("span", _hoisted_12, _toDisplayString(p.practiceName), 1)
                    ])
                  ])
                ]))
              }), 128))
            ], 2),
            (_ctx.errorProceed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createTextVNode("Please select a practice")
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.emitSetSelectFirm()))
              }, " Proceed ")
            ])
          ])
        ])
      ])
    ])
  ]))
}